let menu_links = document.querySelectorAll('.vg-nav a');
let button = document.querySelector('.vg-slider .btn');

function linkNav (link) {
	link = link.target.getAttribute('href');
	if(link.substring(0, 1) === '/') {
		link = link.substring(1);
	}
	let section = document.getElementById(link);
	section.scrollIntoView();
}

for (let i = 0; i < menu_links.length; i++) {
	menu_links[i].addEventListener('click', function (e) {
		linkNav(e);
		e.preventDefault();
	});
}

button.addEventListener('click', function (e) {
	linkNav(e);
	e.preventDefault();
});